import React, {useState, useRef} from 'react'
import BookingListItem from './BookingListItem'
import {formatTime} from '../../utils/time'
import styled from 'styled-components'
import ErrorContainer from '../../components/ErrorContainer'
import Confirm, {CONFIRM_YES} from '../../components/Confirm/Confirm'
import {_L, useLocaleState} from '../../context/LocaleContext'

const BookingList = ({reservation, meeting, onCancel}) => {
  const [showConfirm, setShowConfirm] = useState(false)
  const localeState = useLocaleState()

  let selectedItem = useRef(null)

  const updateMeeting = ({resId}) => {
    selectedItem.current = resId
    setShowConfirm(true)
  }

  const onConfirm = response => {
    if (response === CONFIRM_YES) {
      onCancel(selectedItem.current)
    }
    setShowConfirm(false)
    selectedItem.current = null
  }

  const updateMeetingState = ({occurrences}) => {
    return occurrences
      .map(item => ({
        resId: item.resId,
        date: item.startDate,
        start: item.startTime,
        end: item.endTime
      }))
      .sort((a, b) => a.date - b.date)
  }

  const processMeetingSchedule = meeting => {
    let series = meeting.selectedTimes.map(item => ({
      resId: 0,
      date: item.start,
      start: formatTime(item.start, 'HH:mm'),
      end: formatTime(item.end, 'HH:mm')
    }))

    meeting.exceptions.forEach(exception => {
      let seriesItem = series[exception.index]
      seriesItem.start = exception.start
      seriesItem.end = exception.end
    })
    return series.sort((a, b) => a.date - b.date)
  }

  // If this is a new meeting use the meeting.selectedTimes values to populate the list.
  // Otherwise use the reservation data;

  let bookingList = meeting.isNew
    ? processMeetingSchedule(meeting)
    : updateMeetingState(reservation)

  return (
    <Container>
      <Booking>{_L({key: 'Your booking list', localeState})}</Booking>
      <ContainerForm>
        {bookingList.map((item, idx) => (
          <BookingListItem
            key={idx}
            item={item}
            updateMeeting={updateMeeting}
          />
        ))}
      </ContainerForm>
      <ErrorContainer errorMessage={meeting.submitError} />

      <Confirm
        title={_L({key: 'Cancel Reservation', localeState})}
        message={_L({
          key: 'Are you sure you want to cancel this reservation ?',
          localeState
        })}
        onConfirm={onConfirm}
        isOpen={showConfirm}
      />
    </Container>
  )
}

export default BookingList

BookingList.defaultProps = {
  meeting: {},
  reservation: []
}

const Container = styled.div`
  box-sizing: border-box;
  height: 100%;
  padding: 20px 30px;
  background-color: #eff0f3;
`

const Booking = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #a4a9b7;
`
const ContainerForm = styled.div`
  background-color: #eff0f3;
  height: calc(100vh - 300px);
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
`
